<template>
  <filter-manager
    v-model="this.filters"
    :open-advanced="isOpenAdvanced"
    :icon-button="iconButton"
    :filters="filtersHeader"
    @search="onSearch"
    ref="filter"
    @academicYear="
      updateFiltersData('academicYear', $event, 'onAcademicYearChanged')
    "
    @sieorRegId="updateFiltersData('sieorRegId', $event)"
    @center="updateFiltersData('center', $event, 'onCenterChanged')"
    @municipality="
      updateFiltersData('municipality', $event, 'onMunicipalityChanged')
    "
    @school="updateFiltersData('school', $event)"
    @status="updateFiltersData('status', $event, 'onStatusChanged')"
    @amendmentProcess="updateFiltersData('amendmentProcess', $event)"
  />
</template>

<script>
import FilterManager from 'FilterManager';
import ResourcesService from '@/services/resources.js';
import { createNamespacedHelpers } from 'vuex';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';
const { mapMutations, mapActions, mapState } = createNamespacedHelpers(
  'ubication-tech-assistance-mngmt'
);
import { mapGetters as mapMainGetters } from 'vuex';
import userRoles from '@/utils/constants/userRoles';
import storeMixin from '@/mixin/storeGenerator';
export default {
  name: 'SearchFilter',
  components: {
    FilterManager,
  },
  mixins: [storeMixin],

  data: () => ({
    isOpenAdvanced: false,
    iconButton: 'fas fa-search',
    messages: [],
    providersRoles: [
      userRoles.provider,
      userRoles.assistantprovider,
      userRoles.especialista,
      userRoles.proveedorcpa,
    ],
  }),
  methods: {
    ...mapActions([
      'initFilters',
      'loadResults',
      'loadCenters',
      'onAcademicYearChanged',
      'onCenterChanged',
      'onMunicipalityChanged',
      'onProviderChanged',
      'onStatusChanged',
      'onAmendmentChanged',
    ]),
    ...mapMutations([
      'setFilterValue',
      'resetByMunicipality',
      'resetByAcademicYear',
      'resetResults',
    ]),
    isAmendmentProcessVisible() {
      return this.filters.status?.id == tapRequestStatusesEnum.Enmendado;
    },
    verifyRoleAccess(roles) {
      let roleAccess = false;
      const userRole = this.userRole;

      if (roles === undefined) {
        roleAccess = true; // show
      }

      if (roles) {
        roleAccess = roles.find((x) => x == userRole) ? true : false;
      }

      return roleAccess;
    },
    async onSearch(clear = true) {
      var valid = await this.$refs.filter.$refs.formValidator.validate();
      if (!valid) {
        return false;
      }
      if (clear) {
        this.pagination.currentPage = 1;
      }
      let filterProperties = {
        AcademicYear: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        amendmentprocess: this.filters.amendmentprocess
          ? this.filters.amendmentprocess.id
          : null,
        Filter: this.filters?.sieorRegId ?? null,
        StatusId: this.filters.status ? this.filters.status.id : null,
        CenterId: this.filters.center ? this.filters.center.id : null,
        MunicipalityId:
          this.filters.municipality && this.userRole != userRoles.provider
            ? this.filters.municipality.id
            : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        RequestType: this.filters?.requestType?.id ?? null,
        DeterminationType: this.filters?.determinationType?.id ?? null,
        IsAmended: this.filters?.amendedRequest?.id
          ? this.filters?.amendedRequest?.id == 1
          : null,
        PageIndex: this.pagination.currentPage,
        PageSize: this.pagination.pageSize,
      };
      await this.loadResults(filterProperties);
      this.$emit('close-callout');
    },
    updateFiltersData(key, event, callDispatch) {
      if (event != undefined && event != null && event != '')
        this.setFilterValue({ property: key, data: event });
      //Handle Value Change
      else this.setFilterValue({ property: key, data: null }); //Handle Empty selections

      if (callDispatch != undefined) {
        if (typeof this[callDispatch] == 'function') {
          this[callDispatch]();
        }
      }
    },
  },
  computed: {
    ...mapState([
      'isAdmin',
      'results',
      'filters',
      'collections',
      'pagination',
      'centerDisabled',
      'municipalityDisabled',
      'schoolDisabled',
      'hasAccessLevel',
    ]),
    ...mapMainGetters(['userCenters']),
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filters.academicYear,
          fieldName: 'description',
          fieldKey: 'id',
          class: 'col-sm-6 col-md-3 col-lg-3 ml-0 mr-0',
          classContainer: 'w-100',
          validations: this.filters.sieorRegId == null ? 'required' : '',
          error: this.messages['0675'] ? this.messages['0675'] : null,
          mapParentValue: this.filters.academicYear == null,
          clearable: false,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.collections.status,
          value: this.filters.status,
          class: 'col-sm-6 col-md-6 col-lg-3 ml-0 mr-0',
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.status == null,
        },
        {
          visible: this.isAmendmentProcessVisible(),
          name: 'amendmentProcess',
          component: 'CustomDropDown',
          options: [
            { id: 1, name: 'Sí' },
            { id: 2, name: 'No' },
          ],
          class: 'col-md-2',
          placeholder: 'Proceso de Enmienda',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'sieorRegId',
          component: 'CustomInput',
          placeholder:
            'Escriba Número de SIE, Registro, Solicitud o Nombre del Solicitante',
          value: this.filters.sieorRegId,
          class: this.isAmendmentProcessVisible()
            ? 'col-12 col-sm-12 col-md-4'
            : 'col-12 col-sm-12 col-md-6',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          maskType: 'sieorRegIdNumber',
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          options: this.collections.centers,
          value: this.filters.center,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          disabled:
            this.filters.academicYear == null ||
            this.collections.centers.length == 1,
          mapParentValue: this.filters.center == null,
          isAdvanced: true,
          validations: this.hasAccessLevel ? 'required' : '',
          error: 'El campo Centro es obligatorio',
        },

        {
          name: 'municipality',
          label: !this.verifyRoleAccess(this.providersRoles)
            ? 'Municipio de Residencia:'
            : 'Municipio',
          component: 'CustomDropDown',
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          options: this.collections.municipalities,
          value: this.filters.municipality,
          fieldName: 'name',
          fieldKey: 'id',
          disabled: this.filters.center == null || this.municipalityDisabled,
          mapParentValue: this.filters.municipality == null,
          isAdvanced: true,
          validations: this.hasAccessLevel ? 'required' : '',
          visible: !this.verifyRoleAccess(this.providersRoles),
          error: 'El campo Municipio es obligatorio',
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          options: this.collections.schools,
          value: this.filters.school,
          fieldName: 'name',
          fieldKey: 'id',
          disabled:
            !this.isAdmin &&
            (this.filters.center == null || this.schoolDisabled),
          isAdvanced: true,
          mapParentValue: this.filters.school == null,
          visible: true,
          validations: this.isCenterLevel || this.isAdmin ? '' : 'required',
          error: 'El campo Escuela es obligatorio',
        },
        {
          name: 'requestType',
          label: 'Tipo de Solicitud:',
          component: 'CustomDropDown',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          options: [
            { id: 1, name: 'Nuevo' },
            { id: 2, name: 'Renovación' },
            { id: 3, name: 'Querella' },
          ],
          value: this.filters.requestType,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
          visible: !this.verifyRoleAccess(this.providersRoles),
        },
        {
          name: 'determinationType',
          label: 'Determinación:',
          component: 'CustomDropDown',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          options: [
            { id: 1, name: 'Compra de Servicio' },
            { id: 2, name: 'Reembolso' },
            { id: 3, name: 'Pago Directo' },
          ],
          value: this.filters.determinationType,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
        {
          name: 'amendedRequest',
          label: 'Consulta Enmendada:',
          component: 'CustomDropDown',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          options: [
            { id: 1, name: 'Si' },
            { id: 2, name: 'No' },
          ],
          value: this.filters.amendedRequest,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
          visible: this.showAmendedRequestFilter,
        },
      ];
    },
    disableButton() {
      if (
        this.filters.academicYear == null &&
        this.filters.sieorRegId != null &&
        this.filters.sieorRegId.length >= 8
      )
        return false;
      if (this.filters.academicYear != null) return false;
      return true;
    },
    showAmendedRequestFilter() {
      return (
        this.filters.status?.id ==
        tapRequestStatusesEnum['Proceso de Análisis del(la) Secretario(a)']
      );
    },
    isCenterLevel() {
      const serviceCenters = this.$store.getters['$_user/serviceCenters'] || [];
      return (
        this.hasAccessLevel &&
        this.$store.getters.HasPermission('level.center') &&
        serviceCenters.length > 0
      );
    },
  },
  watch: {
    'pagination.currentPage'(value, oldvalue) {
      if (value !== oldvalue) {
        this.onSearch(false);
      }
    },
  },
  async mounted() {
    this.isOpenAdvanced =
      this.userCenters != null ||
      this.filtersHeader.find(
        (filter) => filter.value != null && filter.isAdvanced
      ) != null ||
      this.userRole == userRoles.ProviderPagoDirecto;

    this.messages = await ResourcesService.LoadValidationMessages([
      '0312',
      '0675',
    ]);

    if (this.results.length) {
      this.loadResults();
    } else {
      await this.initFilters();
    }
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = [
      'uta-validity-request',
      'uta-management',
      'uta-history',
    ];
    next(async (vm) => {
      if (persistRoutes.some((x) => x == from.name)) {
        vm.recoveryData();
      } else {
        vm.shouldRecovery = false;
        vm.isAdvanced = false;
        vm.filterAgain();
      }
    });
  },
};
</script>
